/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { css, jsx } from '@emotion/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { EuiSkeletonText } from '@elastic/eui'

import { useProfile } from '@modules/profile-lib/hooks'
import { useFlagsWhenLoaded } from '@modules/launchdarkly'

const BillingFeedback = () => {
  const profile = useProfile()
  const navigate = useNavigate()
  const [isFlagsUsable, flags] = useFlagsWhenLoaded()
  const decodedUserId = profile && btoa(String(profile.user_id)) // we want to send user_id decoded using base64

  useEffect(() => {
    if (isFlagsUsable && !flags.billingFeedback) {
      // redirect to overview page if billing feedback flag is not enabled
      navigate('../overview')
    }
  })

  return (
    <div css={css({ textAlign: 'center', backgroundColor: '#f6f6f6' })}>
      <iframe
        src={`https://docs.google.com/forms/d/e/1FAIpQLSfqUNOVs9R78SIhL-90gLFwnbAnt9E5nUsGryd3XcVoj6B20w/viewform?embedded=true&entry.1245541789=${decodedUserId}`}
        width='640'
        height='2200'
      >
        <EuiSkeletonText />
      </iframe>
    </div>
  )
}

export default BillingFeedback
